'use client';

import type { ReactNode } from 'react';
import { HttpRenderer } from '../../ToolCallsRenderers/renderers/HttpRenderer';
import type { OutputRenderContext } from '../../tool-config-types';

export const renderHttpResult = (ctx: OutputRenderContext): ReactNode => {
  const { content, maxHeight, onOpenObject } = ctx;
  return (
    <HttpRenderer
      data={content}
      maxHeight={maxHeight}
      onOpenObject={onOpenObject}
    />
  );
};
